import { Icon, symbolName } from './Icon'

type EmailIconProps = Readonly<{
  size?: number
  color?: string
}>

export function EmailIcon({ size = 24, color = '#353535' }: EmailIconProps) {
  return (
    <Icon name={symbolName('envelope', 'mail')} size={size} color={color} />
  )
}
